import { createStyles, makeStyles, Theme } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => createStyles({
  root: {
    width: '100%',
    height: 'auto',
    fontFamily: 'Noto Sans JP',
    fontStyle: 'normal',
  },
  process: {
    margin: '30px auto 50px auto',
  },
  notiTitle: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    marginTop: '20px',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  boxDateAndTine: {
    background: '#F4F5F5',
    borderRadius: '0px',
    margin: '2rem 0px 0px',
    padding: '0.42em 1.5em',
    [theme.breakpoints.down('sm')]: {
      padding: '0.42em 1.5em',
      margin: '20px 0px',
    },
  },
  labelNotiDate: {
    fontSize: '18px',
    lineHeight: '26px',
    color: '#6F7878',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      lineHeight: '18px',
      letterSpacing: '0.28px',

    },
  },
  textNotiDate: {
    fontSize: '16px',
    lineHeight: '24px',
    color: '#CD0021',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
      lineHeight: '18px',
      letterSpacing: '0.28px',
    },
  },
}));

export default useStyles;
